import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSnackbar,
    {
      staticClass: "mt-5 mr-1",
      attrs: { color: _vm.cor, top: "", right: "", timeout: 8000 },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function ({ attrs }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function ($event) {
                        _vm.visibilidadeStatus = false
                      },
                    },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [_c(VIcon, [_vm._v("clear")])],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.visibilidadeStatus,
        callback: function ($$v) {
          _vm.visibilidadeStatus = $$v
        },
        expression: "visibilidadeStatus",
      },
    },
    [_vm._v(" " + _vm._s(_vm.descricao) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }